module.exports = __webpack_public_path__ + "static/media/education2.2201c7a6.png";